const DAY = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });

export function dateRangeLabel(from: string, to: string): string {
  const fmt = (d: string) => DAY.format(new Date(`${d}T00:00:00`));
  if (from && to) return `${fmt(from)} – ${fmt(to)}`;
  if (from) return `from ${fmt(from)}`;
  if (to) return `until ${fmt(to)}`;
  return '';
}

export function filterLabel(parts: (string | false | null | undefined)[]): string | null {
  const active = parts.filter((p): p is string => !!p && p.trim().length > 0);
  return active.length ? active.join(' · ') : null;
}
